<template>
  <div class="event direction-column user-forms">
      <p>{{ $store.getters['getClientMeta'].name }}</p>
      <h3 class="line-title">Üyelik Bilgilerim</h3>
      <div class="col" v-if="!_.isUndefined(validations.detail) && validations.detail.r == 1 && validations.detail.s != 1">
        <div class="alert alert-danger" style="width:100%;margin-bottom:10px"><b>Lütfen eksik bilgilerinizi tamamlayın.</b></div>
      </div>
      <form v-on:submit.prevent="edit" class="inline" :class="{ 'col' : isMobile }">
            <div class="col col-6">
                <div class="inline-form">
                  <label>Adınız</label>
                  <input type="text"
                    :disabled="!(!_.isUndefined(validations.detail) && validations.detail.r == 1 && validations.detail.s != 1)"
                   v-model="detail.name" placeholder="Adınızı yazınız">
                </div>
            </div>
            <div class="col col-6">
                <div class="inline-form">
                  <label>Soyadınız</label>
                  <input type="text" 
                  :disabled="!(!_.isUndefined(validations.detail) && validations.detail.r == 1 && validations.detail.s != 1)"
                  v-model="detail.surname" placeholder="Soyadınızı yazınız">
                </div>
            </div>
            <div class="col col-6">
                <div class="inline-form">
                  <label>Kullanıcı Adınız</label>
                  <input type="text"
                    disabled
                    v-model="detail.username">
                </div>
            </div>
            <div class="col col-6">
                <div class="inline-form">
                  <label>T.C Kimlik No</label>
                  <input type="text" 
                  :disabled="!(!_.isUndefined(validations.detail) && validations.detail.r == 1 && validations.detail.s != 1)" v-model="detail.identification_number" name="identification_number" 
                  class="form-control input-sm">
                </div>
            </div>
            <div class="col col-6">
                <div class="inline-form">
                  <label>E-Mail</label>
                  <input type="email" disabled v-model="detail.email" placeholder="E-Mail Adresiniz">
                </div>
            </div>
            <div class="col col-6">
                <div class="inline-form">
                  <label>Para Birimi</label>
                  <select v-model="detail.currency" disabled>
                    <option value="TRY">TRY</option>
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                  </select>
                </div>
            </div>
            <div class="col col-6">
                <div class="inline-form">
                  <label>Doğum Tarihi</label>
                  <div class="row">
                    <div class="col">
                      <select v-model="detail.date.day">
                        <option v-for="item in 31" :key="item" :value="item">{{ item }}</option>
                      </select>
                    </div>
                    <div class="col">
                      <select v-model="detail.date.month">
                        <option v-for="item in 12" :key="item" :value="item">{{ item }}</option>
                      </select>
                    </div>
                    <div class="col">
                      <select v-model="detail.date.year">
                        <option v-for="item in _.range(1960, 2017)" :key="item" :value="item">{{ item }}</option>
                      </select>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col col-3">
                <div class="inline-form">
                  <label>Ülke</label>
                  <select v-model="detail.country">
                    <option :value="null">Seçiniz</option>
                    <option v-for="(item,key) in countries" :key="key" :value="item.code">{{ item.name }}</option>
                  </select>
                </div>
            </div>
            <div class="col col-3">
                <div class="inline-form">
                  <label>Şehir</label>
                  <input type="text" v-model="detail.city" placeholder="Şehir Yazın">
                </div>
            </div>
            <div class="col col-9">
                <div class="inline-form">
                  <label>Adres</label>
                  <input type="text" v-model="detail.address" placeholder="Adres Yazın">
                </div>
            </div>
            <div class="col col-3">
                <div class="inline-form">
                  <label><br></label>
                  <ButtonLoader class="primary" :loader="btnLoading" :text="'Bilgileri Güncelle'" >
                    <template name="icon">
                      <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                    </template>
                  </ButtonLoader>
                </div>
            </div>
      </form>
      <hr>
      <div class="col">
        <h3>Şifre Güncelleme</h3>
        <br><br>
      </div>
      <form v-on:submit.prevent="password" class="inline" :class="{ 'col' : isMobile }">
        <div class="col col-6">
            <div class="inline-form">
              <label>Eski Şifreniz</label>
              <input type="password" v-model="new_password.old" placeholder="Eski Şifrenizi yazınız">
            </div>
        </div>
        <div class="col col-6">
            <div class="inline-form">
              <label>Yeni Şifreniz</label>
              <input type="password" v-model="new_password.new" placeholder="Yeni Şifrenizi yazınız">
            </div>
        </div>
        <div class="col col-6">
            <div class="inline-form">
              <label>Yeni Şifreniz Tekrarı</label>
              <input type="password" v-model="new_password.new_again" placeholder="Yeni Şifrenizi yazınız">
            </div>
        </div>
        <div class="col col-6">
            <div class="inline-form">
                <label><br></label>
                <ButtonLoader class="primary" :loader="btnPassLoading" :text="'Şifreyi Güncelle'"  >
                  <template name="icon">
                    <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                  </template>
                </ButtonLoader>
            </div>
        </div>
      </form>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import Header from '../../components/Common/User/Header'
  export default{
    data(){
      return{
        detail:{
          name: null,
          surname: null,
          username: null,
          identification_number: null,
          email: null,
          currency: null,
          date: {
            day: null,
            month: null,
            year: null,
          },
          country: null,
          city: null,
          address: null,
        },
        new_password:{
          old: null,
          new: null,
          new_again: null,
        },
        validations:{},
        btnLoading: false,
        btnPassLoading: false,
      }
    },
    components:{
      Header
    },
    watch:{
      user: {
        handler(e) {
          this.setUserInfo();
        },
        deep: true
      },
      user_detail: {
        handler(e) {
          this.setUserInfo();
        },
        deep: true
      }
    },
    created(){
      this.setUserInfo();
    },
    computed:{
      ...mapState("countries", ["countries"]),

      user(){
          return this.$user();
      },
      user_detail(){
          return this.$user_detail();
      }
    },
    methods:{
      setUserInfo(){
        if(this.user_detail){
          this.detail.name = this.user.name;
          this.detail.surname = this.user.surname;
          this.detail.username = this.user.username;
          this.detail.email = this.user.email;
          this.detail.currency = this.user.currency;
          this.detail.username 		= this.user.username;
          this.detail.date.day 		= this.user_detail.detail.birthday_day;
          this.detail.date.month 		= this.user_detail.detail.birthday_month;
          this.detail.date.year 		= this.user_detail.detail.birthday_year;
          this.detail.country 		= this.user_detail.detail.country.indexOf('ksik') >= 0 ? null : this.user_detail.detail.country;
          this.detail.city 			= this.user_detail.detail.city.indexOf('ksik') >= 0 ? null : this.user_detail.detail.city;
          this.detail.address 		= this.user_detail.detail.address.indexOf('ksik') >= 0 ? null : this.user_detail.detail.address;
          this.validations 				= this.user_detail.detail.validations;
          this.detail.identification_number = this.user_detail.detail.identification_number;
          if(_.size(this.detail.identification_number) > 10){
            if(!(!_.isUndefined(this.validations.detail) && this.validations.detail.r == 1 && this.validations.detail.s != 1)){
              this.detail.identification_number = new Array(this.detail.identification_number.length-3).join('*') + this.detail.identification_number.substr(this.detail.identification_number.length-4, 4);
            }
          }
        }
      },
      showLast4(item){
            if(!(!_.isUndefined(this.validations.detail) && this.validations.detail.r == 1 && this.validations.detail.s != 1)){
                if(_.size(item) > 10){
                    item = new Array(item.length-3).join('*') + item.substr(item.length-4, 4);
                }
          }
          return item;
      },
      edit(){
        this.btnLoading = true;
        if(!(!_.isUndefined(this.validations.detail) && this.validations.detail.r == 1 && this.validations.detail.s != 1)){
            this.detail.identification_number = this.detail.identification_number;
        }
        axios.patch('/user', { ...this.detail })
        .then((response)=>{
            this.$store.dispatch('auth/userInit');
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
        })
        .catch(() => {})
        .finally(() => {
          this.btnLoading = false;
        });
      },
      password(){
        this.btnPassLoading = true;
        axios.patch('/user/security/password', { ...this.new_password })
        .then((response)=>{
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
        })
        .catch(() => {})
        .finally(() => {
          this.btnPassLoading = false;
        });
      }
    }
  }
</script>